<template>
  <div class="text-center">
    <v-dialog
      v-model="cargando"      
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Cargando...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
    computed: {
        cargando() {
            return this.$store.getters.cargandoPagina;
        }
    },
}
</script>